import { ComponentPropsWithoutRef, LegacyRef, ReactNode } from 'react';

import './ButtonUnderlined.scss';

export interface ButtonUnderlinedProps extends ComponentPropsWithoutRef<'button'> {
  innerRef?: LegacyRef<HTMLButtonElement>;
  active: boolean;
  children: ReactNode;
}

function ButtonUnderlined({ className, active, children, innerRef, ...rest }: ButtonUnderlinedProps) {
  return (
    <div className="underlined-button-container">
      <button className="underlined-button" {...rest} ref={innerRef}>
        {children}
      </button>
      <div className={`underline ${active ? 'active' : ''}`}></div>
    </div>
  );
}

export default ButtonUnderlined;
